import moment from 'moment';

// Publish age is data staleness: the catalogV2 flag turns the legacy sync off,
// so publishing is the only way a v2 brand's live catalog updates.
export const publishAgeBadge = publishedAt => {
  if (!publishedAt) return null;
  const ageDays = moment().startOf('day').diff(moment(publishedAt).startOf('day'), 'days');
  const ageLabel =
    ageDays <= 0
      ? 'today'
      : ageDays < 30
        ? `${ageDays} ${ageDays === 1 ? 'day' : 'days'} ago`
        : moment(publishedAt).format('MMM D, YYYY');
  return { ageLabel, tone: ageDays <= 1 ? 'fresh' : ageDays < 7 ? 'aging' : 'stale' };
};
